import React from 'react';
import { motion } from 'framer-motion';
const team = [{
  name: 'Khanam Khan',
  role: 'Secretary & Administration Manager',
  bio: 'Specialist in international trade and retail sourcing across UK and European markets.',
  image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=400&h=400'
}, {
  name: 'Annabelle Kan',
  role: 'Sourcing Manager',
  bio: 'Leads our sourcing and market entry initiatives across Asian retail networks and manufacturing hubs.',
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=400&h=400'
}, {
  name: 'Carlos Martinez',
  role: 'European Market Director',
  bio: 'Specialist in EU regulatory compliance, retail buyer relations, and cross-border trade operations.',
  image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=400&h=400'
}, {
  name: 'Sayeeda Habib',
  role: 'Procurement Director',
  bio: 'Expert in supplier negotiations, quality assurance, and large-scale procurement management.',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=400&h=400'
}];
export function TeamSection() {
  return <section className="py-24 bg-[#1a2d4a] relative" data-id="element-554">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-555">
        <div className="mb-16" data-id="element-556">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-557">
            <span className="text-[#d4a853] font-medium tracking-[0.2em] uppercase text-sm block mb-4" data-id="element-558">
              Leadership
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-559">
              Meet Our Experts
            </h2>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-560">
          {team.map((member, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group" data-id="element-561">
              <div className="relative overflow-hidden mb-6 aspect-square border border-white/10" data-id="element-562">
                <img src={member.image} alt={member.name} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500" data-id="element-563" />
                <div className="absolute inset-0 bg-[#d4a853]/0 group-hover:bg-[#d4a853]/20 transition-colors duration-300" data-id="element-564" />
              </div>

              <h3 className="text-xl font-bold text-white mb-1 group-hover:text-[#d4a853] transition-colors" data-id="element-565">
                {member.name}
              </h3>
              <p className="text-[#d4a853] text-sm font-medium uppercase tracking-wider mb-3" data-id="element-566">
                {member.role}
              </p>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-567">
                {member.bio}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}